export default __webpack_public_path__ + "c83d65dd1fb2fd07a2de83059cbc705f.svg";